/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Rephrase_ShortenInputs */



/**
* | output |
* | --- |
* | "Rephrase - Shorten" |
*
* @param {Event_Ad_Rephrase_ShortenInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_rephrase_shorten = /** @type {((inputs?: Event_Ad_Rephrase_ShortenInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Rephrase_ShortenInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reformuler - Raccourcir")
	if (locale === "de") return /** @type {LocalizedString} */ ("Umformulieren - Verkürzen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Riformulare - Accorciare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перефразировать - Сократить")
	if (locale === "es") return /** @type {LocalizedString} */ ("Parafrasear - Acortar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("改写 - 缩短")
	if (locale === "ja") return /** @type {LocalizedString} */ ("言い換え - 短縮")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वाक्य बदलें - संक्षिप्त करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Reformule - Encurte")
	return /** @type {LocalizedString} */ ("Rephrase - Shorten")
});